<template>
  <!--弹窗文本框-->
  <div class="alertText">
    <b>{{ TextData }}</b>
  </div>
</template>
<script>
export default {
  props: {
    sendData: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data() {
    return {
      TextData: {},
    };
  },
  methods: {
    /**
       * Description: 请求数据
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       * Return {Promise}
       */
    schoolSms(data) {
      return new Promise((resolve) => {
        this.$http._post({
          url: 'index/student/schoolSMS',
          data
        }).then(({ data }) => {
          resolve(data);
        });
      });
    },
    /**
       * Description: 处理 Promise 数据展示
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    sendMsg() {
      let data = {};
      Object.assign(data, {
        crm_id: this.$route.params.id,
        school_id: this.sendData.id,
        status: this.sendData.status,
        action: 'text'
      });
      this.schoolSms(data).then((res) => {
        this.TextData = res.message;
      });
    }
  },
  mounted() {
    /**
       * Description: 第一次进页面读取数据
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    this.sendMsg();
  },
  watch: {
    /**
       * Description: 每次变化重新拉取数据
       * Author: yanlichen <yanlichen@tuozhongedu.com>
       */
    sendData: {
      handler: function (val) {
        if (val) {
          this.sendMsg();
        }
      },
      deep: true
    }
  }
};
</script>
<style src="../../assets/css/fontFace.css"></style>
<style>
  .alertText{
    line-height: 30px;
    font-size: 15px;
  }
</style>
